
  import * as storyblokRuntime$UVcmK50I5a1u0oHIQhQmm5QeyOVHp_45Y6mCQFrSS4k5k from '/codebuild/output/src3018036558/src/ark/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 420,
    "sm": 560,
    "md": 768,
    "lg": 1024,
    "xl": 1200,
    "xxl": 1536,
    "2xl": 1440
  },
  "presets": {},
  "provider": "storyblok",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ],
  "quality": 80
},
    providers: {
        ['storyblok']: { provider: storyblokRuntime$UVcmK50I5a1u0oHIQhQmm5QeyOVHp_45Y6mCQFrSS4k5k, defaults: {"baseURL":"https://a.storyblok.com"} }
    }
  }
